import { useContext } from 'react'

import { MeetingsMeetingContext } from 'modules/meetings/lib/context/MeetingsMeetingContext'

interface UseMeetingNotesReturn {
  notes: string | null
  setNotes: (notes: string) => void
  isSavingNotes: boolean
}

export const useMeetingNotes = (): UseMeetingNotesReturn => {
  const context = useContext(MeetingsMeetingContext)

  if (context === undefined) {
    throw new Error('useMeetingNotes must be used within a MeetingsMeetingProvider')
  }

  const { notes, setNotes, isSavingNotes } = context

  return {
    notes,
    setNotes,
    isSavingNotes,
  }
}
